import axiosInstance from "../api/axiosInstance";



export const vaultAnalytics = (params) => {
  return axiosInstance.get(
    "/admin/vault-analytics/question-performance",
    { params }
  );
};

export const fetchFunnelAnalytics = (params) => {
  return axiosInstance.get("/admin/analytics/funnel", { params });
};

export const fetchMatchToChatStats = () => {
  return axiosInstance.get("/admin/analytics/matches-to-chat");
};

export const fetchChatToPurchaseStats = () => {
  return axiosInstance.get("/admin/analytics/purchase-after-chat");
};

export const fetchAvailableCities = () => {
  return axiosInstance.get("/admin/analytics/avilable-city");
};

// Call patterns / call-and-vanish: calls are the one channel the chat
// contact-info filter cannot see, so this watches whether pairs use a
// free-window call as the off-app ramp.
export const fetchCallPatternStats = () => {
  return axiosInstance.get("/admin/analytics/call-patterns");
};

// The doors-open LOOP funnel (2026-08-31): weekly pulse of the core loop
// (introductions -> Vault -> reveal -> chat -> meetup, plus exits).
// People who left, or were removed. Deliberately NOT part of the funnel:
// departed members completed everything before leaving, so a funnel row would
// render the one group with a 100% completion rate as the biggest drop.
export const fetchDepartures = () => {
  return axiosInstance.get("/admin/analytics/departures");
};

export const fetchLoopFunnel = () => {
  return axiosInstance.get("/admin/analytics/loop-funnel");
};

// The Curiouzz Promise dry run (2026-09-01): yesterday's silence sweep -
// who would be prompted or closed if the ladder were live.
export const fetchPromiseDryRun = () => {
  return axiosInstance.get("/admin/promise/dry-run");
};

// Reveal limbo (2026-08-27): first Reveal choice -> mutual reveal timing.
export const fetchRevealLimboStats = () => {
  return axiosInstance.get("/admin/analytics/reveal-limbo");
};